var map = {
	"./answer-lottery.svg": 15827,
	"./arrow-right.svg": 51965,
	"./auction.svg": 49126,
	"./audio-connect.svg": 68358,
	"./audio-muted.svg": 89079,
	"./audio.svg": 20833,
	"./beauty.svg": 41045,
	"./calling.svg": 42102,
	"./camera.svg": 49868,
	"./change.svg": 20209,
	"./checked.svg": 936,
	"./close.svg": 47807,
	"./copy.svg": 90054,
	"./edit.svg": 19687,
	"./emoji.svg": 89070,
	"./error.svg": 11423,
	"./exit.svg": 60054,
	"./eye-close.svg": 78758,
	"./eye.svg": 35596,
	"./full-screen.svg": 82249,
	"./info-forbidden.svg": 2752,
	"./info.svg": 18643,
	"./language.svg": 4948,
	"./layout.svg": 9283,
	"./mic.svg": 84799,
	"./pause.svg": 96734,
	"./play.svg": 66393,
	"./quit-full-screen.svg": 74701,
	"./red-pocket.svg": 74620,
	"./setting.svg": 1232,
	"./share.svg": 39123,
	"./shopping.svg": 66523,
	"./video-connect.svg": 42189,
	"./video-muted.svg": 75751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;